import type { CartManagementValueContext } from '@unity/commerce-core';

export type CommerceEnvironment = CartManagementValueContext['env'];

// Maps our NEXT_PUBLIC_ENVIRONMENT value to a valid commerce-core environment.
const ENVIRONMENT_BY_NEXT_ENV: Readonly<Record<string, CommerceEnvironment>> = {
  development: 'development',
  test: 'test',
  ephemeral: 'test',
  staging: 'staging',
  production: 'production',
};

export const resolveCommerceEnv = (): CommerceEnvironment => {
  // Static reference required: Next.js only inlines NEXT_PUBLIC_* into the
  // client bundle for literal `process.env.NEXT_PUBLIC_*` access. A dynamic
  // lookup (getEnvVar) stays undefined in the browser, so a client component
  // would always hit the fallback below regardless of environment.
  const value = process.env.NEXT_PUBLIC_ENVIRONMENT;
  return ENVIRONMENT_BY_NEXT_ENV[value ?? ''] ?? 'staging';
};

/**
 * commerce-core gates the cart fetch on a non-empty countryCode; derive it
 * from the route locale (e.g. 'en-US' → 'US') so cart-bound actions resolve.
 */
export const countryCodeFromLocale = (locale: string | undefined): string =>
  locale?.split('-')[1]?.toUpperCase() || 'US';
